import React from 'react';

const Privacy = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-bold mb-8 text-center">Privacy Policy</h1>
      <p className="text-gray-600 text-center mb-12">Last updated: January 1, 2024</p>
      
      <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
        <section>
          <h2 className="text-2xl font-bold mb-4">1. Information We Collect</h2>
          <p className="text-gray-700 mb-4">
            We collect information you provide directly to us, such as when you create an account, 
            make a booking, request a test ride, or contact us for support. This information may include:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>Name and contact information (email, phone number, address)</li>
            <li>Account credentials</li>
            <li>Payment information</li>
            <li>Vehicle preferences and booking history</li>
            <li>Communications with us</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">2. How We Use Your Information</h2>
          <p className="text-gray-700 mb-4">
            We use the information we collect to:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>Process your bookings and test ride requests</li>
            <li>Communicate with you about your orders</li>
            <li>Provide customer support</li>
            <li>Improve our products and services</li>
            <li>Send you promotional offers (with your consent)</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">3. Information Sharing</h2>
          <p className="text-gray-700 mb-4">
            We do not sell, trade, or rent your personal information to third parties. We may share information:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>With service providers who assist in our operations</li>
            <li>To comply with legal requirements</li>
            <li>To protect our rights and property</li>
            <li>With your consent</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">4. Data Security</h2>
          <p className="text-gray-700">
            We implement appropriate technical and organizational measures to protect your personal information 
            against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission 
            is completely secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">5. Your Rights</h2>
          <p className="text-gray-700 mb-4">
            You have the right to:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">6. Cookies and Tracking</h2>
          <p className="text-gray-700">
            We use cookies and similar tracking technologies to enhance your browsing experience, 
            analyze site traffic, and personalize content. You can control cookie preferences through 
            your browser settings.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">7. Children's Privacy</h2>
          <p className="text-gray-700">
            Our services are not intended for individuals under 18 years of age. We do not knowingly 
            collect personal information from children. If we become aware of such collection, we will 
            take steps to delete the information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">8. Changes to This Policy</h2>
          <p className="text-gray-700">
            We may update this privacy policy from time to time. We will notify you of any changes by 
            posting the new policy on this page with an updated effective date.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">9. Contact Us</h2>
          <p className="text-gray-700">
            If you have questions about this privacy policy or our data practices, please contact us at:
          </p>
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <p className="text-gray-700">Email: privacy@janvahan.com</p>
            <p className="text-gray-700">Phone: +91 80 1234 5678</p>
            <p className="text-gray-700">Address: Janvahan Towers, Electronic City, Bangalore - 560100</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;